import React, {
  useRef,
} from 'react';
import PropTypes from 'prop-types';

import {
  Field,
  Container,
  Icon,
  Text,
  EditButton,
} from './styles';

const EditableInput = (props) => {
  const {
    onChange,
    onSubmit,
    readOnly,
    onCancel,
    onFocus,
    onClickEdit,
    hasEditButton,
    value,
    readOnlyValue,
  } = props;

  const inputEl = useRef(null);

  onFocus(inputEl);

  const handleChange = (e) => {
    onChange(e);
  };

  const handleEditClick = (e) => {
    onClickEdit(e);
  };

  return (
    <Container>
      {readOnly && (
        <Text>
          {readOnlyValue || value}
          {' '}
          {
            hasEditButton
            && (
              <EditButton
                onClick={handleEditClick}
              >
                Edit
              </EditButton>
            )
          }
        </Text>
      )}
      {!readOnly && (
        <>
          <Field
            value={value}
            onChange={handleChange}
            readOnly={readOnly}
            ref={inputEl}
          />
          <Icon name="check" color="green" onClick={onSubmit} />
          <Icon name="close" color="red" onClick={onCancel} />
        </>
      )}
    </Container>
  );
};

EditableInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onClickEdit: PropTypes.func,
  hasEditButton: PropTypes.bool,
  readOnlyValue: PropTypes.node,
};

EditableInput.defaultProps = {
  readOnly: true,
  onClickEdit: null,
  hasEditButton: false,
  readOnlyValue: null,
};

export default EditableInput;
